import { defineStore } from "pinia";
import { ref } from "vue";
// import { Device } from '@capacitor/device';
import { Platform } from "quasar";

export const usePlatformStore = defineStore("platform", () => {
  const androidVersion = ref(null);
  const platform = ref(null);
  const isAndroid = ref(false);

  const initialize = async () => {
    try {
      // const info = await Device.getInfo();
      const info = await Platform.getInfo();
      platform.value = info.platform || "web";
      isAndroid.value = info.platform === "android";

      if (isAndroid.value) {
        androidVersion.value = info.osVersion || null;
      }

      return { platform: platform.value, androidVersion: androidVersion.value };
    } catch (error) {
      return { platform: "web", androidVersion: null };
    }
  };

  return {
    androidVersion,
    platform,
    isAndroid,
    initialize,
  };
});
